import prop1 from "./img/props/obj1.png";
import prop2 from "./img/props/obj2.png";
import prop3 from "./img/props/obj3.png";
import prop4 from "./img/props/obj4.png";
import prop5 from "./img/props/obj5.png";
import prop6 from "./img/props/obj6.png";
import prop7 from "./img/props/obj7.png";
import prop8 from "./img/props/obj8.png";
import prop9 from "./img/props/obj9.png";
import prop10 from "./img/props/obj10.png";
import prop11 from "./img/props/obj11.png";
import prop12 from "./img/props/obj12.png";
import prop13 from "./img/props/obj13.png";
import prop14 from "./img/props/obj14.png";
import prop15 from "./img/props/obj15.png";
import prop16 from "./img/props/obj16.png";
import prop17 from "./img/props/obj17.png";
import prop18 from "./img/props/obj18.png";

const PROPS = [
  prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8, prop9,
  prop10, prop11, prop12, prop13, prop14, prop15, prop16, prop17, prop18,
];

export default PROPS;
